import Ukiyo from "ukiyojs";
import AOS from "aos";
import PureCounter from "@srexi/purecounterjs";
const block = document.querySelector(".expanded");
const heading = document.querySelector(".expanded-heading");
const expand = document.querySelector("#expand");
const toAnimate = document.querySelector(".plus_vertical");
const parallax = document.getElementsByClassName("ukiyo");
import "aos/dist/aos.css";

document.addEventListener("aos:in", ({ detail }) => {
  console.log("animated in", detail);
});

document.addEventListener("aos:out", ({ detail }) => {
  console.log("animated out", detail);
});

window.addEventListener("load", () => {
  // Code to run on page load
  if (window.innerWidth >= 1025) {
    AOS.init();
    new PureCounter();
    new Ukiyo(parallax, {
      scale: 2, // 1~2 is recommended
      speed: 2, // 1~2 is recommended
      willChange: true,
      wrapperClass: "ukiyo-wrapper",
      externalRAF: false,
    });
  }
  expand.addEventListener("click", () => {
    toAnimate.classList.toggle("minus");
    block.classList.toggle("d-none");
    heading.classList.toggle("d-none");
    setTimeout(() => {
      block.classList.toggle("show");
      heading.classList.toggle("show");
    }, 1);
  });
});

const currURL = window.location.href;

if (
  currURL === "https://stronghold-public.euwest01.umbraco.io/contact/" ||
  currURL === "https://stronghold.se/contact/"
) {
  window.onload = function () {
    const styles = `
.container-block .bg-dotted-grid:has( > .half-width > .image-block) {
    background-repeat: space !important;
    padding: 195px 0;
    @media screen and (width <= 640px) {
    background: none !important;
    padding: 24px !important;
      }
  }
.body > main > div > div:nth-child(2) > div > div > div:nth-child(1) > div > div {
  box-shadow: 20px 0px 0px #fff;
}
`;

    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
  };
}

if (
  currURL === "https://stronghold-public.euwest01.umbraco.io/our-journey/" ||
  currURL === "https://stronghold.se/our-journey/"
) {
  window.onload = function () {
    const styles = `
    .container-block .bg-dotted-grid:has(.half-width>.cms-text-block.text-center.bg-white) {
      padding: 185px 0;
      .half-width .cms-text-block {
        padding: 10px 0;
      }
      @media screen and (max-width: 1513px) {
        background-repeat: space;
        padding: 195px 182px;
      }
      @media screen and (width <= 640px) {
        padding: 100px 0;
        margin-top: 13px;
        }
        @media screen and (width <= 431px) {
          padding: 90px 0;
          background-size: 100%;
          background-repeat: space;
        }
    }
  `;

    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
  };
}
